module.exports = __webpack_public_path__ + "img/3.4594c3b6.png";